exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".blink[data-v-05464003]{animation:blinking-data-v-05464003 1s ease-out 5}@keyframes blinking-data-v-05464003{0%{background-color:#06c3d1}to{background-color:#fff}}.btn-custom[data-v-05464003]{background-color:transparent;border:none;outline:none;padding:.1rem;margin:0}", ""]);

// exports
